import { render, staticRenderFns } from "./DocumentationInferenceAPI.vue?vue&type=template&id=4107852d"
import script from "./DocumentationInferenceAPI.vue?vue&type=script&lang=js"
export * from "./DocumentationInferenceAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports